routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('results', {
      url: '/results/:id',
      template: require('./results.html'),
      controller: 'ResultsController',
      controllerAs: 'results',
      resolve: {
        report: ['$stateParams', 'ReportService', ($stateParams, ReportService) => {
          return ReportService.getById($stateParams.id);
        }]
      }
    });
}



// WEBPACK FOOTER //
// ./src/client/app/results/results.route.js